import { action } from '../utils/requests'

export const getJobs = (countryFilter = null) => action('jobs_categorized', countryFilter && { country: countryFilter })

export const getJobsById = id => action('jobs_by_id', { job_id: id })
